// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"094a43b4","455":"49e520ba","726":"e7824a14","977":"c044fd17"}[chunkId] + ".chunk.js";
};